const SESSION_STORAGE_KEY = 'salesperson-popup-shown';

document.addEventListener('DOMContentLoaded', initBoaSalespersonPopup);

function initBoaSalespersonPopup() {  
  const shouldShow = shouldShowPopup();
  const popup = document.getElementById('boa-salesperson-popup');
  if (!shouldShow || !popup) {
    return;
  }
  setupEventListeners(popup);
  sortBranchDropdown();
  showPopup(popup);
}

function shouldShowPopup() {  
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const popupShown = sessionStorage.getItem(SESSION_STORAGE_KEY);
  
  if (utmSource !== 'store' || popupShown === 'true') {
    return false;
  }
  sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
  return true;
}

function sortBranchDropdown() {
  const selectEl = document.getElementById('boa-salesperson-branch');
  if (!selectEl || selectEl.options.length <= 1) {
    return;
  }
  const options = Array.from(selectEl.options);
  
  // Sort options by store ID (numeric)
  options.sort((a, b) => {
    const idA = Number(a.value) || 0;
    const idB = Number(b.value) || 0;
    return idA - idB;
  });
  
  options.forEach(option => {
    selectEl.appendChild(option);
  });
}

function showPopup(popup) {
  popup.classList.add('active');
  popup.removeAttribute('style');
  document.body.style.overflow = 'hidden';
}

function hidePopup(popup) {
  popup.classList.remove('active');
  popup.style.display = 'none';
  document.body.style.overflow = '';
}

function setupEventListeners(popup) {
  const closeBtn = popup.querySelector('#boa-salesperson-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      handleSkip(popup);
    });
  }

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      handleSkip(popup);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('active')) {
      handleSkip(popup);
    }
  });

  const skipBtn = popup.querySelector('#boa-salesperson-popup-skip');
  if (skipBtn) {
    skipBtn.addEventListener('click', () => {
      handleSkip(popup);
    });
  }

  const form = popup.querySelector('#boa-salesperson-popup-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      handleSave(popup);
    });
  }

  const salespersonIdInput = popup.querySelector('#boa-salesperson-id');
  if (salespersonIdInput) {
    salespersonIdInput.addEventListener('input', (e) => {
      validateSalespersonId(e.target);
    });

    // Only allow numeric input
    salespersonIdInput.addEventListener('keypress', (e) => {
      if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter'].includes(e.key)) {
        e.preventDefault();
      }
    });
  }

  const branchSelect = popup.querySelector('#boa-salesperson-branch');
  if (branchSelect) {
    branchSelect.addEventListener('change', (e) => {
      validateBranch(e.target);
    });
  }
}

function validateSalespersonId(input) {
  const value = input.value.trim();
  const errorEl = document.getElementById('boa-salesperson-id-error');
  const isValid = /^\d+$/.test(value) && value.length >= 3;

  if (value && !isValid) {
    input.classList.add('error');
    if (errorEl) {
      errorEl.classList.add('show');
    }
    return false;
  } else {
    input.classList.remove('error');
    if (errorEl) {
      errorEl.classList.remove('show');
    }
    return true;
  }
}

function validateBranch(select) {
  const value = select.value.trim();
  const errorEl = document.getElementById('boa-salesperson-branch-error');
  const isValid = value !== '';

  if (!isValid) {
    select.classList.add('error');
    if (errorEl) {
      errorEl.classList.add('show');
    }
    return false;
  } else {
    select.classList.remove('error');
    if (errorEl) {
      errorEl.classList.remove('show');
    }
    return true;
  }
}

async function handleSave(popup) {
  const salespersonIdInput = document.getElementById('boa-salesperson-id');
  const branchSelect = document.getElementById('boa-salesperson-branch');
  const saveBtn = document.getElementById('boa-salesperson-popup-save');

  if (!salespersonIdInput || !branchSelect || !saveBtn) {
    return;
  }

  const isSalespersonIdValid = validateSalespersonId(salespersonIdInput);
  const isBranchValid = validateBranch(branchSelect);

  if (!isSalespersonIdValid || !isBranchValid) {
    return;
  }

  const salespersonId = salespersonIdInput.value.trim();
  const branchSaleId = branchSelect.value.trim();

  saveBtn.disabled = true;
  saveBtn.textContent = "";

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          salesperson_id: salespersonId,
          branch_sale_id: branchSaleId
        }
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    await response.json();

    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    hidePopup(popup);

  } catch (error) {
    saveBtn.disabled = false;
    saveBtn.textContent = "שמור";
  }
}

function handleSkip(popup) {
  sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');  
  hidePopup(popup);
}